import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);

const messages = {
  en: {
    SignIn: "SignIn",
    Register: "Register",
    Email: "Email",
    Password: "Password",
    Username: "Username",
    ConfirmPassword: "Confirm Password",
    ForgotPassword: "Forgot Password",
    ResetPasswordLink: "Send a password reset link",
    Profile: "Profile",
    Logout: "Logout",
    NameRequired: "Name is required",
    EmailRequired: "Email is required",
    PasswordRequired: "Password is required",
    ConfirmPasswordRequired: "Confirm password is required",
    ViewCart: "ViewCart",
    Checkout: "Checkout",
    ProfileUpdated: "Profil Profilaktualisierung",
    About: "About",
    PhoneNumber: "Phone Number",
    Image: "Image",
    Update: "Update",
    Products: "Products",
    Address: "Address",
    NoProducts: "No Products for this category",
    Select: "Select",
    CartSummary: "Cart Summary",
    Name: "Name",
    Quantity: "Quantity",
    Price: "Price",
    Total: "Total",
    EmptyCart: "Shopping Cart is empty",
    Address1: "Address 1",
    Address2: "Address 2",
    Shipping: "Choose Shipping Method",
    ChoosePayment: "Choose Payment",
    Payment: "Payment",
    OrderSummary: "Order Summary",
    Next: "Next",
    // // Previous: "Previous",
    Save: "Save",
    BuyNow: "Buy Now",
    AddToCart: "Add to cart",
    NewAddress: "New Address",
    Type: "Type",
    City: "City",
    State: "State",
    Country: "Country",
    Zip: "Zip",
    Back: "Back",
    Create: "Create",
    InvalidCredentials: "Invalid Credentials",
    OrderDetails: "Order Details",
    OrderNumber: "Order Number",
    Amount: "Amount",
    Status: "Status",
    CreatedAt: "Created At",
    User: "User",
    BillingAddress: "Billing Address",
    ShippingAddress: "Shipping Address",
    Items: "Items",
    Description: "Description",
    DeliveryDate: "Delivery Date",
    PaymentDetails: "Payment Details",
    Method: "Method",
    PaymentStatus: "Payment Status",
    SameAsShipping: "Same as shipping",
    SaveAddress: "Save address to my profile",
    DefaultAddress: "Default Address",
    SetDefaultAddress: "Set Default Address",
    ChangePassword: "Change Password",
    OldPassword: "Old Password",
    NewPassword: "New Password",
    ConfirmNewPassword: "Confirm New Password",
    Prev: "Prev",
    // Next: "Next",
    Filter: "Filter",
    Paymentmethod: "Payment Method",
    Ratings: "Ratings",
    Comment: "Comment",
  },
  de: {
    SignIn: "Einloggen",
    Register: "Registrieren",
    Email: "Email",
    Password: "Passwort",
    Username: "Vorname und Nachname",
    ConfirmPassword: "Neues Passwort bestätigen",
    ForgotPassword: "Passwort vergessen",
    ResetPasswordLink: "Link zum Zurücksetzen des Passworts senden",
    Profile: "Profil",
    NameRequired: "Name ist erforderlich",
    EmailRequired: "E-Mail ist erforderlich",
    PasswordRequired: "Passwort wird benötigt",
    ConfirmPasswordRequired: "Passwort bestätigen ist erforderlich",
    ViewCart: "Warenkorb ansehen",
    Checkout: "Auschecken",
    Logout: "Ausloggen",
    ProfileUpdated: "Profil Profilaktualisierung",
    About: "Über",
    PhoneNumber: "Telefonnummer",
    Image: "Bild",
    Update: "Aktualisierenaktualisieren",
    NoProducts: "Keine Produkte für diese Kategorie",
    Products: "Produkte",
    Address: "Adresse",
    Select: "Sortieren nach",
    CartSummary: "Warenkorb Zusammenfassung",
    Name: "Name",
    Quantity: "Menge",
    Price: "Preis",
    Total: "Gesamt",
    EmptyCart: "Ihr Warenkorb ist leer",
    Address1: "Addresse 1",
    Address2: "Addresse 2",
    Shipping: "Versandmethode auswählen",
    Payment: "Zahlung",
    ChoosePayment: "Wählen Sie Zahlung",
    OrderSummary: "Bestellübersicht",
    Next: "Weiter",
    // Previous: "Bisherige",
    Save: "Speichern",
    BuyNow: "Jetzt kaufen",
    AddToCart: "In den Warenkorb",
    NewAddress: "Neue Adresse",
    Type: "Art",
    City: "Stadt",
    State: "Zustand",
    Country: "Land",
    Zip: "Postleitzahl",
    Back: "Zurück",
    Create: "Erstellen",
    InvalidCredentials: "Ungültige Anmeldeinformationen",
    OrderDetails: "Bestelldetails",
    OrderNumber: "Bestellnummer",
    Amount: "Menge",
    Status: "Status",
    CreatedAt: "Anzeige erstellt",
    User: "Benutzer",
    BillingAddress: "Rechnungsadresse",
    ShippingAddress: "Lieferanschrift",
    Items: "Artikel",
    Description: "Beschreibung",
    DeliveryDate: "Lieferdatum",
    PaymentDetails: "Zahlungsdetails",
    Method: "Methode",
    PaymentStatus: "Zahlungsstatus",
    SameAsShipping: "Wie Lieferadresse",
    SaveAddress: "Adresse in meinem Profil speichern",
    DefaultAddress: "Standardadresse",
    SetDefaultAddress: "Standardadresse festlegen",
    ChangePassword: "Passwort ändern",
    OldPassword: "Altes Passwort",
    NewPassword: "Neues Passwort",
    ConfirmNewPassword: "Bestätige neues Passwort",
    Prev: "Zurück",
    Filter: "Filter",
    // Next: "Nächster",
    Paymentmethod: "Zahlungsmethode",
    Ratings: "Bewertungen",
    Comment: "Komment",
  },
};

const i18n = new VueI18n({
  locale: "de",
  fallbackLocale: "de",
  messages,
});

export default i18n;
